import { Step1, type Step1Data } from './step1'
import { Step2, type Step2Data } from './step2'
import { Step3, type Step3Data } from './step3'

export type AllStepsData = Step1Data & Step2Data & Step3Data

export const steps = [
  <Step1 key="simulation1" />,
  <Step2 key="simulation2" />,
  <Step3 key="simulation3" />,
]
